import { TradingViewTimeframesEnum } from '@modules/trading-view-module/enums/trading-view-timeframes.enum'

export const SupportedResolutions: TradingViewTimeframesEnum[] = [
	TradingViewTimeframesEnum.oneMinute,
	TradingViewTimeframesEnum.threeMinutes,
	TradingViewTimeframesEnum.fiveMinutes,
	TradingViewTimeframesEnum.fifteenMinutes,
	TradingViewTimeframesEnum.thirtyMinutes,
	TradingViewTimeframesEnum.oneHour,
	TradingViewTimeframesEnum.twoHours,
	TradingViewTimeframesEnum.threeHours,
	TradingViewTimeframesEnum.fourHours,
	TradingViewTimeframesEnum.oneDay,
	TradingViewTimeframesEnum.oneWeek,
	TradingViewTimeframesEnum.oneMonth,
	TradingViewTimeframesEnum.oneYear,
]
